import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, createLazyComponent, type LazyComponent } from 'owa-bundling';
import store from './store/publicFolderPickerStore';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PublicFolderPickerModule" */ './lazyIndex'),
    { name: 'PublicFolderPickerModule' }
);

export const lazyLoadPublicFolders: LazyImport<
    typeof lazyIndex.loadPublicFolders,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.loadPublicFolders);
export const LazyPublicFolderPicker: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.PublicFolderPicker,
    undefined,
    undefined,
    { onlyImportIf: () => store().showPanel || store().showErrorDialog }
);
export const lazyRemovePublicFolderFromFavorites: LazyImport<
    typeof lazyIndex.removePublicFolderFromFavorites,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removePublicFolderFromFavorites);
